export default function () {
  return [

    { key: 'orgId', type: 'org', selectProps: { clearable: true, multiple: false } },
    { key: 'branchId', label: "businessUnit", type: 'bu', selectProps: { clearable: true, multiple: false } }
  ]
}
